import { render, staticRenderFns } from "./doHandleyb.vue?vue&type=template&id=6ca8c237&"
import script from "./doHandleyb.vue?vue&type=script&lang=js&"
export * from "./doHandleyb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports